// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'semantic-ui-css/semantic.min.css';
import App from './components/CoreComponents/App';

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(<App />);
